import _isEqual from 'lodash/isEqual'
import { memo } from 'react'
import { Text, View } from 'react-native'
import { match } from 'ts-pattern'

import { SCREEN_SIZE } from '@nxt-insurance/ui-kit/constants'
import type { Color } from '@nxt-insurance/ui-kit/types'

import type { Section } from '@/cms/sections'
import { BlockContent } from '@/components/renderers/BlockContent'
import { useWindowWidth } from '@/hooks/useWindowWidth'
import type { PortableTextComponentProps } from '@portabletext/react'

import { FadeIn } from './FadeIn'
import { sectionStyles } from './styles'

type CoverTemplate = Extract<Section, { _type: 'templates.cover' }>

const COVER_WIDTH = 1200

const CoverTemplateRenderer = (props: {
  node: PortableTextComponentProps<CoverTemplate>
  index: number
  backgroundColor?: Color
  contentColor?: Color
}) => {
  const { value } = props.node
  const windowWidth = useWindowWidth()

  if (windowWidth === 0) {
    return null
  }

  const styles = sectionStyles({
    layout: 'cover',
    hyphenatedSubheading: true,
    hyphenatedHeading: true,
  })

  const media = match(value.media)
    .with({ typeOfMedia: 'image' }, ({ image }) => image)
    .with({ typeOfMedia: 'video' }, ({ video }) => video)
    .exhaustive()

  const space = windowWidth <= SCREEN_SIZE.M ? 'large' : 'xlarge'

  return (
    <FadeIn layout="cover" id="cover">
      <View className={styles.headingContainer()}>
        <Text className={styles.heading()} role="heading" aria-level={2}>
          {value.heading}
        </Text>
        {/* https://necolas.github.io/react-native-web/docs/accessibility/ */}
        {/* @ts-expect-error role paragraph is valid role */}
        <Text className={styles.subheading()} role="paragraph">
          {value.subheading}
        </Text>
      </View>
      <View className={styles.supportingContentContainer()}>
        <BlockContent
          blocks={[media, value?.inlineColumns]}
          sectionName="cover"
          space={space}
          align="center"
          width={COVER_WIDTH}
        />
      </View>
    </FadeIn>
  )
}

export const CoverTemplate = memo(CoverTemplateRenderer)
